import { render, staticRenderFns } from "./SelectButtonQuestionOptions.vue?vue&type=template&id=45720b86&scoped=true"
import script from "./SelectButtonQuestionOptions.vue?vue&type=script&lang=js"
export * from "./SelectButtonQuestionOptions.vue?vue&type=script&lang=js"
import style0 from "./SelectButtonQuestionOptions.vue?vue&type=style&index=0&id=45720b86&prod&scoped=true&lang=css"
import style1 from "./SelectButtonQuestionOptions.vue?vue&type=style&index=1&id=45720b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45720b86",
  null
  
)

export default component.exports